import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h2>ALT <span className='footer-brand-flow'>Flow</span></h2>
        </div>
        
        <div className="footer-columns">
          <div className="footer-column">
            <h3 className="footer-column-title">Product</h3>
            <div className="footer-links">
              <a href="#pricing" className="footer-link">Pricing</a>
              <a href="#overview" className="footer-link">Overview</a>
              <a href="#browse" className="footer-link">Browse</a>
              <a href="#accessibility" className="footer-link">Accessibility</a>
              <a href="#five" className="footer-link">Five</a>
            </div>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-column-title">Support</h3>
            <div className="footer-links">
              <a href="#contact" className="footer-link">Contact Us</a>
              <a href="#developers" className="footer-link">Developers</a>
              <a href="#documentation" className="footer-link">Documentation</a>
              <a href="#integrations" className="footer-link">Integrations</a>
              <a href="#reports" className="footer-link">Reports</a>
              <a href="#webinar" className="footer-link">Webinar</a>
            </div>
          </div>
          
          <div className="footer-column">
            <h3 className="footer-column-title">Company</h3>
            <div className="footer-links">
              <a href="#about" className="footer-link">About</a>
              <a href="#press" className="footer-link">Press</a>
              <a href="#events" className="footer-link">Events</a>
              <a href="#careers" className="footer-link">Careers</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© 2025 FLOW All rights reserved</p>
          </div>
          
          <div className="footer-legal">
            <a href="#terms" className="footer-link">Terms</a>
            <a href="#privacy" className="footer-link">Privacy</a>
            <a href="#contact" className="footer-link">Contact</a>
          </div>
          
          <div className="footer-social">
            <a href="#youtube" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" fill="currentColor"/>
                <path d="m9.75 15.02 5.75-3.27-5.75-3.27v6.54z" fill="#ffffff"/>
              </svg>
            </a>
            <a href="#facebook" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#twitter" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#instagram" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" fill="currentColor"/>
                <path d="m16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" fill="#ffffff"/>
                <path d="M17.5 6.5h.01" fill="#ffffff"/>
              </svg>
            </a>
            <a href="#linkedin" className="social-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" fill="currentColor"/>
                <rect x="2" y="9" width="4" height="12" fill="currentColor"/>
                <circle cx="4" cy="4" r="2" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
